import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateBioLink = createAsyncThunk('updateBioLink/updateBioLink', async (data) => {
  
    var bodyFormData = new FormData();
    bodyFormData.append("show_profile_photo", data?.showProfilePhoto,)
    bodyFormData.append("show_title", data?.showTitle,)
    bodyFormData.append("show_paragraph", data?.showParagraph,)
    bodyFormData.append("show_banner", data?.showBanner,)
    bodyFormData.append("title", data?.title,)
    bodyFormData.append("about_us", data?.about_us,)
    bodyFormData.append("background_type", data?.backgroundType,)
    bodyFormData.append("background_color", data?.background_color)
    bodyFormData.append("font_family", data?.font_family)
    bodyFormData.append("font_color", data?.font_color)
    bodyFormData.append("social_links", JSON.stringify(data?.social_links))
    bodyFormData.append("youtube_videos", JSON.stringify(data?.youtube_videos || []))
    bodyFormData.append("profile_type", data?.profilePhoto === null ? '1' : '')
    bodyFormData.append("banner_type", data?.bannerImage === null ? '1' : '')
    bodyFormData.append("path", 'upload')
    bodyFormData.append("profile_photo", data?.profilePhoto,)
    bodyFormData.append("banner_image", data?.bannerImage,)

    try {
        const res = await axios({
            method: 'POST',
            url: process.env.REACT_APP_API_URL + `profile_social_link`,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

